import React from "react";
import { useDispatch } from "react-redux";
/*import {
  configurationCleanSearchText,
  configurationSetSearchText,
  cleanSearchingConfigurationsPaginated,
  startSearchingConfigurationPaginated,
} from "../../app/actions/configurationActions";*/

import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { cleanSearchingConfigurationsPaginated, configurationCleanSearchText, configurationSetSearchText, startSearchingConfigurationsPaginated } from "../../app/actions/configurationActions";
import { debugLogPages } from "../../app/helpers/debugHelper";

const SearchBackConfiguration = ({ searchText, setSearchText, itemsPerPage }) => {
  debugLogPages(":: SearchBackConfiguration");
  
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const onChangeInput = (event) => {
    setSearchText(event.target.value);

    if (event.target.value !== "") {
      trackEvent({ component: "SearchConfigurations", event: "SearchConfigurations-Clicked", search: event.target.value });

      dispatch(configurationSetSearchText(event.target.value));

      dispatch(startSearchingConfigurationsPaginated(event.target.value, 0, itemsPerPage));
    } else {
      
      dispatch(cleanSearchingConfigurationsPaginated());

      dispatch(configurationCleanSearchText());
    }
  };

  return (
    <div className="row height d-flex justify-content-center align-items-center">
      <div className="col-md-8">
        <div className="search">
          <i className="fa fa-search"></i>
          <input
            type="text"
            className="form-control"
            placeholder={t("general.option_search")}
            value={searchText}
            id="searchText"
            name="searchText"
            onChange={onChangeInput}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default SearchBackConfiguration;
